<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><span aria-label="page 3" epub:type="pagebreak" id="page_3" role="doc-pagebreak"><img alt="Image" class="imagefp" src="e9781534440180/images/f0003-01.jpg"/></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01a.vue?73e54aee